// extracted by mini-css-extract-plugin
export default {"section1":"HomeTopIntro_section1__klvIT","flex1":"HomeTopIntro_flex1__sQ76n","flex2":"HomeTopIntro_flex2__0cwFK","developer":"HomeTopIntro_developer__DbHq4"};